import styled from 'styled-components'

export const PaymentPageIcons = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 10px;
`
